import { render } from "./TableCompositions.vue?vue&type=template&id=6efc9953"
import script from "./TableCompositions.vue?vue&type=script&lang=js"
export * from "./TableCompositions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__